export default __webpack_public_path__ + "static/media/Information.ac12e7b5.svg";